export const UPDATE_CACHED_MEDIA_LIST = 'UPDATE_CACHED_MEDIA_LIST';
